export default {
  "hero.title": "海量高清正版视频",
  "hero.titleHighlight": "尽在爱液视频",
  "hero.subtitle": "爱液视频官网，您的专属正版视频平台。汇聚海量优质内容，支持多终端流畅播放，随时随地享受极致视觉体验。",
  "hero.cta": "立即体验",
  "hero.secondary": "了解更多",
  "hero.stats.members": "注册会员",
  "hero.stats.videos": "正版视频",
  "hero.stats.categories": "内容分类",
  "category.title": "探索精彩分类",
  "category.subtitle": "涵盖影视、综艺、动漫、纪录片等多元内容分类，满足您的不同观影需求",
  "category.viewAll": "查看全部",
  "featured.title": "热门推荐",
  "featured.subtitle": "精选优质正版视频内容，为您推荐最受欢迎的热门作品",
  "featured.watchNow": "立即观看",
  "featured.free": "免费",
  "featured.vip": "会员专享",
  "membership.title": "加入会员，解锁无限精彩",
  "membership.subtitle": "成为爱液视频会员，畅享海量专属内容、超清画质、无广告干扰等多项特权",
  "membership.monthly": "月度会员",
  "membership.quarterly": "季度会员",
  "membership.yearly": "年度会员",
  "membership.price": "元/月",
  "membership.feature1": "海量正版内容",
  "membership.feature2": "超清4K画质",
  "membership.feature3": "无广告干扰",
  "membership.feature4": "多终端同步",
  "membership.feature5": "离线下载",
  "membership.feature6": "专属客服",
  "membership.cta": "立即开通",
  "membership.hot": "热门",
  "advantages.title": "为什么选择爱液视频",
  "advantages.subtitle": "我们致力于为用户提供最优质的正版视频服务",
  "advantages.genuine.title": "正版授权",
  "advantages.genuine.desc": "所有内容均获得正版授权，为您提供合法、安全的观影体验，支持创作者和版权方。",
  "advantages.quality.title": "超清画质",
  "advantages.quality.desc": "支持1080P至4K超清画质播放，智能适配网络环境，自动调节最佳清晰度。",
  "advantages.multiDevice.title": "多端同步",
  "advantages.multiDevice.desc": "手机、平板、电脑、电视全覆盖，观影记录和收藏自动云端同步，随时随地继续观看。",
  "advantages.offline.title": "离线下载",
  "advantages.offline.desc": "会员支持视频离线下载，无网络环境也能畅享精彩内容，通勤出行不再无聊。",
  "faq.title": "常见问题",
  "faq.subtitle": "快速了解爱液视频的常见问题，如有更多疑问欢迎联系客服",
  "faq.q1": "爱液视频支持哪些设备观看？",
  "faq.a1": "爱液视频支持手机（iOS/Android）、平板、电脑（Windows/Mac）以及智能电视等多种设备，一个账号即可在所有设备上同步使用。",
  "faq.q2": "会员订阅后可以随时取消吗？",
  "faq.a2": "可以的，您可以在会员到期前随时取消自动续费，取消后当前会员周期内的权益不受影响，仍然可以正常使用至到期日。",
  "faq.q3": "视频画质支持哪些清晰度？",
  "faq.a3": "我们支持流畅、标清、高清、超清1080P以及4K等多种清晰度选项，系统会根据您的网络环境智能推荐最佳画质。",
  "faq.q4": "如何联系客服获取帮助？",
  "faq.a4": "您可以通过官网在线客服、官方邮箱service@aiyivideo.com或拨打客服热线400-888-8888联系我们，客服工作时间为每天9:00-21:00。",
  "faq.q5": "支持哪些支付方式？",
  "faq.a5": "我们支持微信支付、支付宝、银联卡以及Apple Pay等多种支付方式，确保您的支付安全便捷。",
  "cta.title": "开启您的高清观影之旅",
  "cta.subtitle": "立即注册爱液视频会员，畅享海量正版高清内容",
  "cta.button": "免费注册",
  "newsletter.title": "订阅最新资讯",
  "newsletter.subtitle": "第一时间获取最新内容上线、会员优惠活动和平台动态",
  "newsletter.placeholder": "请输入您的邮箱地址",
  "newsletter.button": "订阅",
  "newsletter.success": "订阅成功！感谢您的关注。",
  "newsletter.error": "订阅失败，请稍后重试。",
};